import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './stores/'
import './registerServiceWorker'
import './style'
import 'vue-material-design-icons/styles.css'

import '@/filters/date'
import { projectAuth } from '@/firebase/config'

Vue.config.performance = true
Vue.config.productionTip = false

let app: any

// initialize app after firebase setup
projectAuth.onAuthStateChanged(async () => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: (h: any) => h(App),
    }).$mount('#app')
  }
})
